module.exports = __webpack_public_path__ + "media/images/user-placeholder-67ea0ac1.jpg";